// @flow
import Enum from '@rover/react-lib/types/Enum';

export default class FooterTheme extends Enum<string> {
  static LIGHT = new FooterTheme('light');
  static DARK = new FooterTheme('dark');
  static isLocked = true;
}



// WEBPACK FOOTER //
// ../react-lib/src/styles/FooterTheme.js